import { useMutation,useQuery,useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { useAuth } from '../../lib/auth'

type Preference={layout:'classic'|'modern'}
export function usePortalAppearance(enabled=true){
  const {me}=useAuth()
  const key=['portal-appearance',me?.id]
  const client=useQueryClient()
  const query=useQuery({queryKey:key,queryFn:()=>api.get<Preference>('/api/account/portal-appearance'),enabled:enabled&&!!me,staleTime:Infinity})
  const save=useMutation({mutationFn:(layout:Preference['layout'])=>api.put<Preference>('/api/account/portal-appearance',{layout}),onSuccess:data=>client.setQueryData(key,data)})
  return {layout:query.data?.layout??'classic',loading:query.isLoading,failed:query.isError,saving:save.isPending,saveError:save.isError,setLayout:save.mutate}
}

export function PortalAppearanceControl(){
  const pref=usePortalAppearance()
  return <div className="portal-appearance-control">
    <label><span>Portal view</span><select aria-label="Portal view" className="input" value={pref.layout} disabled={pref.loading||pref.saving||pref.failed}
      onChange={e=>pref.setLayout(e.target.value as Preference['layout'])}>
      <option value="classic">Classic</option><option value="modern">New look</option>
    </select></label>
    {(pref.failed||pref.saveError)&&<span role="status">Couldn’t save your view. Please try again.</span>}
  </div>
}
